<mat-card>
  <p class="ip"> Your IP: {{ getIp | async }} </p>
</mat-card>
